import RestaurantForm from './RestaurantForm'

export default RestaurantForm
